import React from 'react';
import { useEssentials } from '../../contexts/essentials-context';
import { Box, Text } from '@wix/design-system';
import { Badge } from '.';
import s from './badge-tooltip.module.scss';

export interface AppBenefitsBadgeProps {
  showBorder?: boolean;
  appName: string;
  size?: 'tiny' | 'small' | 'medium';
}

export function AppBenefitsBadge({
  showBorder,
  appName,
  size = 'small',
}: AppBenefitsBadgeProps) {
  const { t, experiments } = useEssentials();

  const isConversionV2 =
    experiments?.enabled('specs.app-market.AppBenefitsConversionV2') ?? false;

  const badgeLabel = isConversionV2
    ? t('app.benefits.badge.v2')
    : t('app.benefits.badge');

  const tooltipText = isConversionV2
    ? t('app.benefits.badge.tooltip.v2', { appName })
    : t('app.benefits.badge.tooltip', { appName });

  return (
    <Badge
      skin="neutralSuccess"
      dataHook="app-benefit-badge"
      uppercase={false}
      showBorder={showBorder}
      size={size}
      tooltipContent={
        <Box direction="vertical" gap="6px">
          <Text
            size="small"
            weight="thin"
            // @ts-expect-error wds types are incompatible
            skin="light"
            className={s.tooltipText}
          >
            {tooltipText}
          </Text>
        </Box>
      }
    >
      <Box marginTop="2px">
        <Text size="tiny" weight="normal">
          {badgeLabel}
        </Text>
      </Box>
    </Badge>
  );
}
